var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMouseUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.4095 0.9123 -0.9123 -0.4095 682.6902 -206.0628)",
    style: {
      fill: "#C0BCC1"
    },
    cx: 408.033,
    cy: 117.906,
    rx: 113.108,
    ry: 92.168
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.4095 0.9123 -0.9123 -0.4095 701.0529 -208.6055)",
    style: {
      fill: "#AEA8AF"
    },
    cx: 418.037,
    cy: 122.577,
    rx: 88.858,
    ry: 65.549
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.4095 -0.9123 0.9123 -0.4095 39.049 261.0897)",
    style: {
      fill: "#C0BCC1"
    },
    cx: 104.02,
    cy: 117.908,
    rx: 113.108,
    ry: 92.168
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.4095 -0.9123 0.9123 -0.4095 20.6857 258.563)",
    style: {
      fill: "#AEA8AF"
    },
    cx: 94.021,
    cy: 122.587,
    rx: 88.858,
    ry: 65.549
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9C6CA"
    },
    d: "M455.998,334.154c0-123.076-95.999-246.151-199.998-246.151S56.002,211.078,56.002,334.154 c0,66.779,54.79,128.318,141.65,147.595c15.539,13.799,35.932,22.25,58.347,22.25s42.808-8.45,58.347-22.25 C401.208,462.471,455.998,400.932,455.998,334.154z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C0BCC1"
    },
    d: "M120.002,338.556c0-99.278,43.188-198.519,100.922-245.873 c-89.53,23.424-164.921,132.41-164.921,241.471c0,65.935,53.475,126.683,138.433,146.765 C147.802,449.3,120.002,395.691,120.002,338.556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C0BCC1"
    },
    d: "M288,475.248H224l-32-9.387c0,6.937,2.868,13.693,8.223,18.103 c15.177,12.498,34.58,20.035,55.776,20.035c21.197,0,40.6-7.537,55.776-20.035c5.355-4.41,8.223-11.166,8.223-18.103L288,475.248z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5DCB4"
    },
    d: "M256,383.999c22.091,0,40,14.327,40,32c0,17.044-16.811,26.018-28.943,32.654 c-7.033,3.846-15.08,3.846-22.113,0c-12.133-6.636-28.943-15.61-28.943-32.654C216,398.326,233.908,383.999,256,383.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEA8AF"
    },
    d: "M284,487.998c-8.383,0-16.539-2.414-23.598-6.984c-2.758-1.781-6.047-1.781-8.805,0 c-7.059,4.57-15.215,6.984-23.598,6.984c-14.637,0-28.258-7.309-36.434-19.555c-2.453-3.672-1.465-8.641,2.211-11.094 c3.66-2.461,8.637-1.477,11.094,2.211c5.203,7.789,13.848,12.438,23.129,12.438c5.289,0,10.441-1.527,14.902-4.414 c8.078-5.227,18.117-5.234,26.195,0c4.461,2.887,9.613,4.414,14.902,4.414c9.285,0,17.93-4.648,23.125-12.438 c2.449-3.68,7.406-4.676,11.098-2.219c3.672,2.453,4.664,7.422,2.215,11.094C312.264,480.685,298.643,487.998,284,487.998z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C969E"
    },
    d: "M471.993,472.002c-1.09,0-2.191-0.227-3.25-0.695c-56.804-25.293-133.396-39.297-134.166-39.438 c-4.348-0.785-7.234-4.945-6.449-9.293c0.781-4.344,4.926-7.266,9.293-6.449c3.207,0.578,79.233,14.469,137.83,40.563 c4.035,1.797,5.852,6.527,4.055,10.563C477.977,470.232,475.055,472.002,471.993,472.002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C969E"
    },
    d: "M504.005,415.999c-0.594,0-1.199-0.066-1.801-0.203c-52.628-12.113-148.865-7.848-149.838-7.805 c-4.367,0.027-8.156-3.211-8.359-7.625c-0.203-4.414,3.211-8.156,7.625-8.359c4.031-0.184,99.421-4.398,154.158,8.195 c4.309,0.992,6.996,5.285,6.004,9.59C510.942,413.495,507.645,415.999,504.005,415.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C969E"
    },
    d: "M40.006,472.002c-3.063,0-5.984-1.77-7.313-4.75c-1.797-4.035,0.02-8.766,4.055-10.563 c58.597-26.094,134.623-39.984,137.83-40.563c4.375-0.82,8.512,2.102,9.293,6.449c0.785,4.348-2.102,8.508-6.449,9.293 c-0.77,0.141-77.362,14.145-134.166,39.438C42.197,471.775,41.092,472.002,40.006,472.002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C969E"
    },
    d: "M7.995,415.999c-3.645,0.004-6.938-2.504-7.789-6.207c-0.992-4.305,1.695-8.598,6.004-9.59 c54.733-12.598,150.115-8.379,154.158-8.195c4.414,0.203,7.828,3.945,7.625,8.359c-0.203,4.418-3.875,7.766-8.359,7.625 c-0.969-0.051-97.233-4.301-149.838,7.805C9.194,415.932,8.589,415.999,7.995,415.999z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B3F4E"
    },
    d: "M172.001,352L172.001,352c-15.4,0-28-12.6-28-28v-16c0-15.4,12.6-28,28-28l0,0c15.4,0,28,12.6,28,28 v16C200.001,339.4,187.401,352,172.001,352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D5360"
    },
    d: "M172.001,280.001c-1.369,0-2.682,0.214-4,0.406V320c0,8.836,7.164,16,16,16c8.837,0,16-7.164,16-16 v-12C200.001,292.6,187.401,280.001,172.001,280.001z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 171.998,
    cy: 299.997,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B3F4E"
    },
    d: "M339.999,352L339.999,352c-15.4,0-28-12.6-28-28v-16c0-15.4,12.6-28,28-28l0,0c15.4,0,28,12.6,28,28 v16C367.999,339.4,355.399,352,339.999,352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D5360"
    },
    d: "M339.999,280.001c-1.369,0-2.682,0.214-4,0.406V320c0,8.836,7.164,16,16,16c8.837,0,16-7.164,16-16 v-12C367.999,292.6,355.399,280.001,339.999,280.001z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 339.996,
    cy: 299.997,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBC9A0"
    },
    d: "M240,407.579c0-8.507,2.769-16.34,7.384-22.793C229.444,387.944,216,400.697,216,415.998 c0,17.043,16.811,26.018,28.943,32.654c7.033,3.846,15.081,3.846,22.113,0c0.512-0.28,1.069-0.592,1.597-0.881 C256.544,439.583,240,428.499,240,407.579z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseUserIcon);
export default __webpack_public_path__ + "static/media/mouse-user-icon.e69cbac4d123e492136039553bd48bab.svg";
export { ForwardRef as ReactComponent };